/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var Redo = new Class({
    redoActive:false,
    stashedRedoElements:[],
    unstashRedoElements:function(){
        //remove stashed elements.
        this.redoActive = false;
        this.stashedRedoElements.empty();

        setTimeout(function(){
            this.setViewPosition(true);
            this.playBot();
        }.bind(this),500);
    },
    popRedoElements:function(triggerKey){
        //pop stashed elements.
        var triggerIndex = [];
        this.stashedRedoElements.each(function(stashedObj,index){
            if(stashedObj.key == triggerKey){
                triggerIndex.push(index);
            }
        });

        this.stashedRedoElements = this.stashedRedoElements.slice(triggerIndex[0],this.stashedRedoElements.length);
        this.stashedRedoElements.each(function(object){
            object.contains.each(function(renderItem){
                if(renderItem.render !== false){
                    if(renderItem.eid){
                        this.render(renderItem, renderItem.eid, false, true);
                    }
                }
            }.bind(this));
        }.bind(this));

        this._State.append(this.stashedRedoElements);
        this.unstashRedoElements();
    },
    isInStashedRedoElements:function(item, key){
        var results = this.stashedRedoElements.filter(
            function(stashedObj,i){
                return stashedObj.key == item.key;
            }
        );
        return results.length > 0;

    },
    stashRedoElements:function(before, after, data){
        if (!this._FullState || !this._FullState.length) {
            this._FullState = this._State
        }
        this._State = before;
        if(after.length){
            after.each(function(obj, i){
                obj.rendered.each(function(element,i){
                    if($(element)){
                        var el = $(element);
                        obj.contains[i].html = el.clone(true,true);

                        var redoButtons = $(element).getElements('.icon--redoWrapper');

                        // If we have redo button on chat baloon,
                        // so remove it
                        if(redoButtons && redoButtons.length > 0){
                            redoButtons.forEach(function(redoBtn){
                                redoBtn.dispose();
                            })
                        }

                        // If el has any data (question)
                        // make it answered
                        if(el.hasClass('holds--data')){
                            el.addClass('isAnswered');
                        }

                        // Add `isRedone` class to all stashed getElements
                        // and remove their ID
                        el.addClass('isRedone').removeProperty('id');
                    }else{
                        obj.contains[i].html = true;
                    }
                });
                if(obj.key != data.key){
                    this.stashedRedoElements.push(obj);
                }
            }.bind(this));
        }
    },
    redoPromptActive:false,
    hidePrompt:function(){
        this.redoPromptActive = false;
        $$('.user--prompt').setStyles({
            'opacity':0,
            'height':0
        });

        setTimeout(function(){
            $$('.user--prompt').dispose();
        },500);
    },
    redoPrompt:function(triggerKey){
        if(this.redoPromptActive){
            this.redoPromptActive = false;
            return;
        }
        this.redoPromptActive = true;
        var prompt = '<div class="user--prompt">'+
                        '<div class="bot--avatar prompt"></div>'+
                        '<div class="prompt--content">'+
                            '<div class="prompt--text">'+
                                '<span>'+
                                'I saved all of your answers for the next questions,'+
                                'would you like me to continue where you left of?'+
                                '</span>'+
                            '</div>'+
                            '<div class="prompt--options">'+
                                '<a class="prompt--button yes" id="prompt_yes"><span>Yes</span></a>'+
                                '<a class="prompt--button no" id="prompt_no"><span>No</span></a>'+
                            '</div>'+
                        '</div>'+
                    '</div>'

        $('after').appendHTML(prompt,'before');
        $('prompt_yes').addEvents({
            click:function(e){
                e.preventDefault();
                this.popRedoElements(triggerKey);
                this.hidePrompt();

            }.bind(this)
        });
        $('prompt_no').addEvents({
            click:function(e){
                e.preventDefault();
                this.unstashRedoElements();
                this.hidePrompt();

            }.bind(this)
        })
    },
    redo: function(data, element, isEmpty, force){
        if (!force && (this.redoActive || this.isRendering)) {
            return;
        }

        this.redoActive = true;
        this.stashedRedoElements.empty();
        var answerElement = $(element);
        if (element) {
            element.removeClass('isAnswered');
        }

        var _s = this._State.slice();
        var _id = data.eid;
        var _index = 0;
        var _obj = {};

        _s.each(function(object,index){
            if(object.rendered.indexOf(_id) >= 0){

                // Index should be -1 if redo was made to answer
                if(object.type === "question"){
                    _index = index;
                } else {
                    _index = index > 0 ? index - 1 : 0;
                }

                _obj = object;
            }
        });

        var itemsBefore = _s.slice(0,_index);
        var itemsAfter = _s.slice(_index,_s.length);
        var itemsAfter_clean = [];

        this.stashRedoElements(itemsBefore, itemsAfter, data);

        // If redo made on the question which has rendered answer
        if(data.type == 'answer'){
            // Add `redoTarget` class to the answer bubble
            // Needed for getting the value and put it inside of the
            // input field
            if (!isEmpty) {
                var answersByUsers = $$('.answer--bubble.by--user');

                if (answersByUsers && answersByUsers.length > 0) {
                    answersByUsers.each(function(answer, i){
                        if(answer.get('family').toInt() == data.key){
                            answer.addClass('redoTarget');
                        }
                    }.bind(this));
                }
            }
            // itemsBefore.each(function(item, index){
            //     if( item.key == _obj.key &&
            //         item.type == 'question'
            //     ){
            //         var renderObject = item.contains.getLast();
            //             renderObject.redo = true;
            //
            //         if(!renderObject.eid){
            //             renderObject.eid = this.newRandomId(_s);
            //         }
            //
            //         this.render(renderObject, renderObject.eid, false, true);
            //     }
            // }.bind(this));
        }
        // If redo made on the question which doesn't have rendered answer
        var inputWrapper = $$('.input--wrapper');

        // If we have active input add animation and then remove from DOM
        if(inputWrapper && inputWrapper.length > 0){
            inputWrapper.forEach(function(el){
                el.dispose();
            })
        }
        this.userAction('redo', element);
        this.redoActive = false;
        // Render the same question if not already playing
        setTimeout(function() {
            this.playBot();
        }.bind(this), 0)
    }
});
